export default __webpack_public_path__ + "static/media/Infor.82157bab.png";